import { Button, Tooltip, TooltipTrigger } from "@light-technology/components";
import {
  Check,
  Copy01,
  HelpCircle,
  LinkExternal01,
  Mail01,
  Phone,
} from "@untitledui/icons";

const ActionToIcon = {
  email: Mail01,
  copy: Copy01,
  link: LinkExternal01,
  phone: Phone,
};

type DetailItemProps = {
  label: string;
  value: string | null | undefined;
  actions: ("email" | "link" | "phone" | "copy")[];
  /** Explains a field whose name does not carry its meaning on its own. */
  tooltip?: string;
};

export const DetailItem = (props: DetailItemProps) => {
  return (
    <div className="flex min-w-0 items-start gap-md">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <div className="text-sm font-medium text-secondary">
            {props.label}
          </div>
          {props.tooltip && (
            <Tooltip title={props.tooltip} placement="top" arrow>
              <TooltipTrigger className="cursor-pointer text-fg-quaternary transition duration-200 hover:text-fg-quaternary_hover focus:text-fg-quaternary_hover">
                <HelpCircle className="size-4" />
              </TooltipTrigger>
            </Tooltip>
          )}
        </div>
        <div
          className="truncate text-sm whitespace-pre-line"
          title={props.value ?? undefined}
        >
          {props.value ?? "-"}
        </div>
      </div>
      {props.value &&
        props.actions.map((a) => (
          <Button
            key={a}
            size="sm"
            color="tertiary"
            iconLeading={ActionToIcon[a]}
            iconLeadingOnClick={a === "copy" ? Check : undefined}
            href={
              a === "link"
                ? props.value!
                : a === "phone"
                  ? `tel:${props.value!}`
                  : a === "email"
                    ? `mailto:${props.value!}`
                    : undefined
            }
            target={a === "link" ? "_blank" : undefined}
            rel={a === "link" ? "noopener noreferrer" : undefined}
            onClick={
              a === "copy"
                ? () => {
                    navigator.clipboard.writeText(props.value!);
                  }
                : undefined
            }
            tooltip={
              a === "copy"
                ? `Copy ${props.label.toLowerCase()} to clipboard`
                : a === "phone" && props.value
                  ? `Call ${props.value}`
                  : a === "email" && props.value
                    ? `Email ${props.value}`
                    : undefined
            }
            tooltipOnClick={
              a === "copy" ? `${props.label} copied to clipboard` : undefined
            }
          />
        ))}
    </div>
  );
};
